import React from 'react';
import { shape, string } from 'prop-types';

import ConfirmationModal from '../../containers/Modals/ConfirmationModal';

import classes from './ScoringErrorModal.module.css';

const ScoringErrorModal = ({ error, ...props }) => (
    <ConfirmationModal
        cancelable={false}
        confirmText="OK"
        title="Scoring Error Message"
        {...props}
    >
        <dl className={classes.error}>
            <dt>Target</dt>
            <dd>{error.target}</dd>

            <dt>Error Message</dt>
            <dd>{error.message}</dd>

        </dl>
    </ConfirmationModal>
);


ScoringErrorModal.defaultProps = {
    error: {}
};

ScoringErrorModal.propTypes = {
    error: shape({
        notes:    string,
        ruleName: string
    })
};

export default ScoringErrorModal;
